const queryKeys = {
  GET_TICKET: 'GET_TICKET',
  GET_ACTIONS: 'GET_ACTIONS',
  GET_WORKSPACES: 'GET_WORKSPACES',
  GET_BOARDS: 'GET_BOARDS',
  GET_CONNECTIONS: 'GET_CONNECTIONS',
  GET_CONFIGURATIONS: 'GET_CONFIGURATIONS',
  GET_CONTENTFUL_DATA: 'GET_CONTENTFUL_DATA',
  GET_WORKROLE_OPTIONS: 'GET_WORKROLE_OPTIONS',
  GET_WORKTYPE_OPTIONS: 'GET_WORKTYPE_OPTIONS',
  GET_COMPANIES: 'GET_COMPANIES',
  GET_CONTACTS: 'GET_CONTACTS',
  GET_FLOWS: 'GET_FLOWS',
  GET_TIME_ENTRIES: 'GET_TIME_ENTRIES',
  GET_TIME_OPTIONS: 'GET_TIME_OPTIONS',
  GET_COPILOT_CHAT_MESSAGES: 'GET_COPILOT_CHAT_MESSAGES',
  SEND_COPILOT_CHAT_QUESTION: 'SEND_COPILOT_CHAT_QUESTION',
  GET_FLOW_FILTER_OPERATORS: 'GET_FLOW_FILTER_OPERATORS',
  GET_MEMBERS: 'GET_MEMBERS',
  GET_PRIORITIES: 'GET_PRIORITIES',
  GET_STATUSES: 'GET_STATUSES'
};

export default queryKeys;
